<template>
  <header>
    <slot></slot>
  </header>
</template>

<script>
export default {
  name: "amHeader"
};
</script>

<style lang="scss" scoped>
</style>
